import React from 'react'
import { QuoteClient } from './Component.client'
import type { QuoteBlock as QuoteBlockType } from '@/payload-types'

export async function QuoteBlock(props: QuoteBlockType & { className?: string }) {
  return <QuoteClient {...props} />
}
